import { Text, VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CustomButton, Layout, MessageWithIcon } from "@lubbezposrednio-frontend/commons";

export const VoteConfirmFailedScreen: React.FC = () => {
  useEffect(() => {
    document.title = "Błąd potwierdzenia głosowania";
  }, []);

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  // Faza D: organizator wymaga podpisu cyfrową tożsamością — web nie podpisuje, kieruj do aplikacji.
  const walletRequired = searchParams.get("wallet") === "1";

  return (
    <Layout>
      <VStack spacing={0} flex={1} py={{ base: 0, sm: "135px" }} maxW="100vw">
        <MessageWithIcon
          image="/ICON_voting.svg"
          title={walletRequired ? "Potwierdź w aplikacji" : "Nieprawidłowy link"}
          message={
            walletRequired ? (
              <Text>
                To głosowanie wymaga potwierdzenia <b>podpisem cyfrowej tożsamości</b> — z przeglądarki nie da się go
                złożyć. Otwórz powiadomienie w aplikacji <b>lubbezposrednio</b> i zatwierdź głos tam. W razie problemów{" "}
                <Link to={`/glosowanie/${id}`} style={{ textDecoration: "underline" }}>
                  skontaktuj się z organizatorem
                </Link>
                .
              </Text>
            ) : (
              <Text>
                Link do potwierdzenia oddania głosu jest nieprawidłowy, przeterminowany lub był wcześniej użyty. W razie
                problemów{" "}
                <Link to={`/glosowanie/${id}`} style={{ textDecoration: "underline" }}>
                  skontaktuj się z organizatorem
                </Link>
                .
              </Text>
            )
          }
          bottomElement={
            <Link to="/" tabIndex={-1}>
              <CustomButton
                text="Strona główna"
                backgroundColor="accent"
                mb="-20px"
                display={{ base: "flex", md: "none" }}
                w="200px"
              />
            </Link>
          }
          isError
        />
        <Link to="/" tabIndex={-1}>
          <CustomButton
            text="Strona główna"
            backgroundColor="accent"
            my="50px"
            display={{ base: "none", md: "flex" }}
          />
        </Link>
      </VStack>
    </Layout>
  );
};
